import React from 'react';
import { motion } from 'framer-motion';
import { Compass, Map, Users } from 'lucide-react';
export function About() {
  const features = [{
    icon: <Compass className="w-6 h-6 text-sunset-600" data-id="element-1" />,
    title: 'Guided Discovery',
    description: "Expert led expeditions into Hungary's hidden valleys and peaks."
  }, {
    icon: <Users className="w-6 h-6 text-sunset-600" data-id="element-2" />,
    title: 'Kindred Spirits',
    description: 'Connect with fellow explorers who share your reverence for nature.'
  }, {
    icon: <Map className="w-6 h-6 text-sunset-600" data-id="element-3" />,
    title: 'Forgotten Paths',
    description: 'We venture beyond the markers to find the stories etched in stone.'
  }];
  return <section className="py-20 md:py-32 bg-earth-100 relative overflow-hidden" data-id="element-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-6">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-7">
            <span className="text-forest-800 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-8">
              Our Philosophy
            </span>
            <h2 className="text-4xl md:text-5xl font-serif text-forest-900 mb-6 leading-tight" data-id="element-9">
              Walking is the best way to read the landscape.
            </h2>
            <p className="text-lg text-stone-600 mb-6 leading-relaxed" data-id="element-10">
              At Fableworld, we believe every trail tells a story. Founded in
              the heart of Budapest, we are a collective of hikers, dreamers,
              and nature enthusiasts dedicated to exploring the wilder side of
              Hungary.
            </p>
            <p className="text-lg text-stone-600 mb-10 leading-relaxed" data-id="element-11">
              Whether you seek the solitude of the deep forest or the
              camaraderie of a campfire, our groups offer a sanctuary from the
              noise of modern life. We walk slowly, breathe deeply, and leave no
              trace but footprints.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8" data-id="element-12">
              {features.map((feature, idx) => <div key={idx} className="flex flex-col gap-3" data-id="element-13">
                  <div className="bg-white p-3 rounded-full w-fit shadow-sm border border-earth-200" data-id="element-14">
                    {feature.icon}
                  </div>
                  <h3 className="font-serif font-bold text-forest-900 text-lg" data-id="element-15">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-stone-600" data-id="element-16">
                    {feature.description}
                  </p>
                </div>)}
            </div>
          </motion.div>

          {/* Image Grid */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-17">
            <div className="grid grid-cols-2 gap-4" data-id="element-18">
              <div className="space-y-4 mt-12" data-id="element-19">
                <img src="https://images.unsplash.com/photo-1551632811-561732d1e306?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Hikers on a ridge" className="rounded-2xl shadow-xl w-full h-64 object-cover" data-id="element-20" />
                <img src="https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Forest details" className="rounded-2xl shadow-xl w-full h-48 object-cover" data-id="element-21" />
              </div>
              <div className="space-y-4" data-id="element-22">
                <img src="https://images.unsplash.com/photo-1501555088652-021faa106b9b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Mountain view" className="rounded-2xl shadow-xl w-full h-48 object-cover" data-id="element-23" />
                <img src="https://images.unsplash.com/photo-1533240332313-0db49b459ad6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Group hiking" className="rounded-2xl shadow-xl w-full h-64 object-cover" data-id="element-24" />
              </div>
            </div>

            {/* Decorative element */}
            <div className="absolute -z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-earth-200/30 rounded-full blur-3xl" data-id="element-25" />
          </motion.div>
        </div>
      </div>
    </section>;
}